import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  selector: 'onboarding-favorite-suggestion',
  imports: [OnboardingContainerComponent, TranslocoPipe],
  templateUrl: './favorite-suggestion.component.html',
})
export class FavoriteSuggestionComponent {
  readonly #router = inject(Router);

  public goBack = () => this.#navigate(commonRoutes.postlogin.onboarding.inProgress);
  public wantAnotherSavingsPlan = () => this.#navigate(commonRoutes.postlogin.onboarding.savingsPlan.alternative);
  public goNext = () => this.#navigate(commonRoutes.postlogin.onboarding.savingsPlan.top3Issuers);

  readonly #navigate = (route: string) => this.#router.navigateByUrl(route);
}
